/* ALVA add to cart: send product forms through Shopify's cart API instead of a full-page form POST.
   Why: Shopify (and through it Meta, TikTok, Klaviyo...) only emits its "product added to cart" event for
   cart API calls. A classic <form action="/cart/add"> POST emits nothing, so Meta never received an
   AddToCart from the Sense page (checked on the live store: form POST = no event, /cart/add.js = AddToCart).
   For the shopper nothing changes: after adding, they land on the cart page, as before.
   If anything fails, the form is submitted the normal way, so adding to the cart can never break.
   Opt in with <form data-alva-atc> (the Sense form #as-product-form is listed below). */
(function () {
  if (window.__alvaAtc) return;
  window.__alvaAtc = true;

  var SELECTOR = 'form#as-product-form, form[data-alva-atc]';
  var PIXEL_GRACE_MS = 350;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  // The Meta pixel sends its AddToCart request ~20 ms after the cart API answers (measured on the live store).
  // Leaving the page at that exact moment can cut it off, so give it a short head start. No pixel loaded
  // (e.g. the visitor has not accepted cookies) = no wait.
  function afterPixel(go) {
    if (typeof window.fbq === 'function') setTimeout(go, PIXEL_GRACE_MS);
    else go();
  }
  window.alvaAfterPixel = afterPixel; // other ALVA scripts that add to cart and then redirect can reuse it

  // One AddToCart, not two (found 2026-10-08, Meta was receiving two events with different ids per click).
  // Shopify's own tracker (shop_events_listener) attaches, on window load, to every form whose action contains
  // "/cart/add" and publishes an "Added Product" event the moment it is submitted, unless the submit is already
  // cancelled or the form has no action. Our fetch to /cart/add.js is tracked by Shopify too (once, after the
  // answer), so both fired. The submit handlers that cancel it run too late (document level, after the form's own
  // listeners), so the action attribute is hidden only while this one submit event is dispatched and put back at
  // the end of the dispatch (and again on the next tick as a safety net). Nothing else reads the action here:
  // we post to cart/add.js ourselves and the corrector pack handler posts to routes.cart_add_url.
  var hiddenActions = [];
  function restoreActions() {
    while (hiddenActions.length) {
      var h = hiddenActions.pop();
      if (!h.form.hasAttribute('action')) h.form.setAttribute('action', h.action);
    }
  }
  window.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches(SELECTOR) || !window.fetch || !window.FormData) return;
    var action = form.getAttribute('action');
    if (!action) return;
    hiddenActions.push({ form: form, action: action });
    form.removeAttribute('action');
    setTimeout(restoreActions, 0);
  }, true);
  window.addEventListener('submit', restoreActions, false);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches(SELECTOR) || e.defaultPrevented) return;
    if (!window.fetch || !window.FormData) return; // old browser: normal submit
    e.preventDefault();
    if (form.getAttribute('aria-busy') === 'true') return;

    var btn = form.querySelector('[type="submit"]');
    function unlock() {
      form.removeAttribute('aria-busy');
      if (btn) btn.disabled = false;
    }
    form.setAttribute('aria-busy', 'true');
    if (btn) btn.disabled = true;

    fetch(root + 'cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function (res) {
      if (!res.ok) throw new Error('add ' + res.status);
      return res.json();
    }).then(function () {
      afterPixel(function () { window.location.href = root + 'cart'; });
    }).catch(function () {
      unlock();
      HTMLFormElement.prototype.submit.call(form); // normal form POST: Shopify shows its own message if the item can't be added
    });
  });

  // Coming back with the browser's Back button must not leave the button disabled.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    document.querySelectorAll(SELECTOR).forEach(function (form) {
      form.removeAttribute('aria-busy');
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.disabled = false;
    });
  });
})();
